import { RichTextElement } from "@redotech/redo-model/content-builder/element-schema";
import { quillStyles } from "@redotech/redo-model/quill-styles";
import htmlReactParser from "html-react-parser";
import { memo } from "react";
import { getBaseElementStyles } from "./base-element-styles";
import { getRichTextContainerStyles } from "./rich-text-shared-styles";

export const RichText = memo(function RichText({
  element,
}: {
  element: Omit<RichTextElement, "id" | "type"> & {
    id: string | number;
    type: string;
  };
}) {
  const containerId = `container-${element.id}`;
  const baseStyles = getBaseElementStyles(element);

  return (
    <>
      <style>
        {/* TODO - Find a way to include all the quill styles automatically */}
        {getRichTextContainerStyles(containerId, element.linkColor)}
        {quillStyles}
      </style>
      <div
        id={containerId}
        style={{
          ...baseStyles,
          color: element.textColor,
          fontSize: element.fontSizePx,
          fontFamily: `'${element.fontFamily}'`,
          lineHeight: 1.42, // match Quill Editors
        }}
      >
        {htmlReactParser(element.html)}
      </div>
    </>
  );
});
